import { render } from "./GenerateChart.vue?vue&type=template&id=54f152a0"
import script from "./GenerateChart.vue?vue&type=script&lang=js"
export * from "./GenerateChart.vue?vue&type=script&lang=js"
script.render = render

export default script